import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, palette, custom }: Theme) => ({
    root: {
      fontFamily: 'Caveat',
      textAlign: 'right',
      lineHeight: 1,
      fontWeight: 700,
      [breakpoints.down(1024)]: {
        textAlign: 'left',
        marginLeft: 10,
      },
      [breakpoints.down(500)]: {
        marginLeft: 0,
      },
    },
    title: {
      fontSize: 20,
      lineHeight: '24px',
      color: palette.primary.main,
    },
    desc: {
      fontSize: 20,
      lineHeight: '24px',
      color: custom.grey[3],
    },
  })
);
